import React from 'react';

import * as S from './styles';

import { LargeBrandImage } from './BrandImage';

/**
 * This layout is used for pages the _only_ want to display
 * the Modern Health branding and not allow the users to exit.
 */
export const TakeoverLayout: React.FC = props => {
    return (
        <>
            <LargeBrandImage />
            <S.Content data-testid="appContent">{props.children}</S.Content>
        </>
    );
};
